import { ClientGateway } from "@kex/api";

import type { RequisitesMessage } from "./types";

import { getRequisitesCaptionMessages as getKyrgyzstanCaptionMessages } from "./kyrgyzstan";
import { getRequisitesCaptionMessages as getRussianRequisitesCaptionMessages } from "./russian";

export type RequisitesCaptionAccount = {
  country: ClientGateway.BankAccountCountryEnum;
  details: ClientGateway.BankAccountDetailsModel;
  name: string;
};

export const getRequisitesCaptionMessages = (
  clientType: ClientGateway.ClientTypesEnum,
  account: RequisitesCaptionAccount,
): RequisitesMessage[] => {
  if (account.country === "RUSSIA") {
    return getRussianRequisitesCaptionMessages(
      clientType,
      account.details as ClientGateway.BankAccountDetailsRussiaModel,
      account.name,
    );
  }
  if (account.country === "KYRGYZSTAN") {
    return getKyrgyzstanCaptionMessages(
      clientType,
      account.details as ClientGateway.BankAccountDetailsKyrgyzstanModel,
      account.name,
    );
  }

  return [];
};
